module.exports = " <form :action=url class=\"vue-dropzone dropzone\" :id=id> <slot></slot> </form> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/index.vue
 ** module id = 9
 ** module chunks = 0
 **/